import { useLanguage } from '../context/LanguageContext';

export default function HowItWorks() {
  const { t } = useLanguage();
  const steps = ['1', '2', '3', '4'].map((n) => ({
    n,
    title: t(`how.${n}.title`),
    body: t(`how.${n}.body`),
  }));

  return (
    <ol className="steps">
      {steps.map((s) => (
        <li className="step card" key={s.n}>
          <span className="step__num">{s.n}</span>
          <h3 className="step__title">{s.title}</h3>
          <p>{s.body}</p>
        </li>
      ))}
    </ol>
  );
}
